import { parseAsStringEnum, useQueryState } from 'nuqs';

const options = parseAsStringEnum(['doctor', 'nurse', 'support']);

/**
 * @param {boolean} [isDirector]
 */
export const useChatRoleSelection = (isDirector) => {
  const [selectedChatRole, setSelectedChatRole] = useQueryState('pscr', options);
  const [messagingSelectedChatRole, setMessagingSelectedChatRole] = useQueryState('access', options);

  if (!isDirector || selectedChatRole) {
    return { selectedChatRole, setSelectedChatRole };
  }

  return { selectedChatRole: messagingSelectedChatRole, setSelectedChatRole: setMessagingSelectedChatRole };
};
